import React, { useState, useEffect } from 'react';
import { Header } from '../common_v2/components/Header';
import { Footer } from '../common_v2/components/Footer';
import { useAuthentication } from '../Login/hooks/useAuthentication';
import { alertModal, isMobileScreen } from '@apply/ui';
import {
    PanelDemo,
    PanelHeaderDemo,
    ToggleButtonDemo,
    IconButtonDemo,
    TextBoxDemo,
    ExpanderDemo,
    FontStylesDemo,
    ButtonDemo,
    ProgressDonutDemo,
    MenuDemo,
    FlyoutMenuButtonDemo,
    SliderDemo,
    TabPanelDemo,
    GenericPopupDemo,
    MultilineTextBoxDemo,
    ProgressBreadcrumbListDemo,
    SelectionPanelGroupDemo,
    DropDownBoxDemo,
    NumberBoxDemo,
    ProgressSpinnerDemo,
    DateTimeBoxDemo,
    AddressLocationDemo,
    CheckButtonDemo,
    CardDemo,
    TableDemo,
} from '@apply/components';

export const ControlDemo: React.FC = () => {
    const { isRegisteredUser, authentication } = useAuthentication();
    const [loading, setLoading] = useState<boolean>(false);
    const [loadError, setLoadError] = useState<string>('');

    useEffect(() => {
        setLoading(false);
        setLoadError('');
    }, [authentication?.username]);

    useEffect(() => {
        if (loadError) {
            alertModal({
                message: 'An error has occurred while communicating with our server.  Please try your operation again.',
                onConfirm: () => {
                    setLoadError('');
                },
            });
        }
    }, [loadError]);

    const demoTabs = [
        { title: 'Font Styles', content: <FontStylesDemo /> },
        { title: 'Panel', content: <PanelDemo /> },
        { title: 'Panel Header', content: <PanelHeaderDemo /> },
        { title: 'Card', content: <CardDemo /> },
        { title: 'Toggle Button', content: <ToggleButtonDemo /> },
        { title: 'Icon Button', content: <IconButtonDemo /> },
        { title: 'Text Box', content: <TextBoxDemo /> },
        { title: 'Drop Down Box', content: <DropDownBoxDemo /> },
        { title: 'Number Box', content: <NumberBoxDemo /> },
        { title: 'Multiline Text Box', content: <MultilineTextBoxDemo /> },
        { title: 'Expander', content: <ExpanderDemo /> },
        { title: 'Progress Donut', content: <ProgressDonutDemo /> },
        { title: 'Button', content: <ButtonDemo /> },
        { title: 'Menu', content: <MenuDemo /> },
        { title: 'Flyout Menu Button', content: <FlyoutMenuButtonDemo /> },
        { title: 'Slider', content: <SliderDemo /> },
        { title: 'Tab Panel', content: <TabPanelDemo /> },
        { title: 'Generic Popup', content: <GenericPopupDemo /> },
        { title: 'Progress Breadcrumb List', content: <ProgressBreadcrumbListDemo /> },
        { title: 'Selection Panel Group', content: <SelectionPanelGroupDemo /> },
        { title: 'Progress Spinner', content: <ProgressSpinnerDemo /> },
        { title: 'Date Time Box', content: <DateTimeBoxDemo /> },
        { title: 'Address Location', content: <AddressLocationDemo /> },
        { title: 'Check Button', content: <CheckButtonDemo /> },
        { title: 'Table', content: <TableDemo /> },
    ];

    const [selectedIndex, setSelectedIndex] = useState(0);

    return (
        <>
            {!loading && isRegisteredUser && authentication?.username ? (
                <>
                    <div className='app-container'>
                        <Header />
                        <main>
                            <div className='content'>
                                <div className='contentSection full'>
                                    <div className={isMobileScreen() ? 'mobilePadding' : ''}>
                                        <h3>Control Demo:</h3>
                                        <br />
                                        <div style={{ display: 'flex', minHeight: '600px' }}>
                                            {/* Simulated vertical tabs */}
                                            <div style={{ width: '150px', borderRight: '1px solid #ccc' }}>
                                                {demoTabs.map((tab, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => setSelectedIndex(index)}
                                                        style={{
                                                            padding: '10px',
                                                            cursor: 'pointer',
                                                            backgroundColor: selectedIndex === index ? '#e0e0e0' : '#fff',
                                                            borderBottom: '1px solid #ddd',
                                                            borderRadius: '10px 0px 0px 10px',
                                                        }}
                                                    >
                                                        {tab.title}
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Tab content */}
                                            <div style={{ flex: 1, padding: '20px', border: '1px solid lightgrey' }}>
                                                {demoTabs[selectedIndex].content}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                    <Footer />
                </>
            ) : (
                <div
                    className='overlay'
                    data-testid='home-page-loading'
                >
                    <div className='overlay__inner'>
                        <div className='overlay__content'>
                            <span className='spinner'></span>
                            <span className='spinner-text'>Loading</span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
